import "./Dropdown.css";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";

export const Dropdown = ({
  options,
  id,
  isOpen,
  selectedAccount,
  selectedOrganization,
  handleSelection,
  handleDropDown,
  setAccountRequired,
  placeholder,
  setOrganizationRequired,
}) => {
  return (
    <div className="dropdown-root">
      <button
        type="button"
        className="dropdown-button"
        onClick={handleDropDown}
        aria-expanded={isOpen}
      >
        {id === "account" ? (
          <p>{selectedAccount ? selectedAccount : placeholder}</p>
        ) : id === "type" ? (
          <p>
            {selectedOrganization ? selectedOrganization.label : placeholder}
          </p>
        ) : id === "bankList" ? (
          <p>
            {selectedOrganization ? selectedOrganization.label : placeholder}
          </p>
        ) : (
          <p>{selectedOrganization ? selectedOrganization : placeholder}</p>
        )}
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </button>

      {isOpen ? (
        <ul className="dropdown">
          {id === "account"
            ? options.map((option) => {
                console.log(
                  "!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!" +
                    JSON.stringify(option) +
                    " " +
                    option.value
                );
                return (
                  <li
                    className="option"
                    key={option.value}
                    onClick={() => {
                      handleSelection(option.value);
                      setAccountRequired("");
                    }}
                  >
                    {option.value}
                  </li>
                );
              })
            : id === "type"
            ? options.map((option) => {
                return (
                  <li
                    className="option"
                    key={option.value}
                    onClick={() => {
                      handleSelection(option);
                      setOrganizationRequired("");
                    }}
                  >
                    {option.label}
                  </li>
                );
              })
            : id === "bankList"
            ? options.map((option) => (
                <li
                  className="option"
                  key={option.value}
                  onClick={() => {
                    handleSelection(option);
                    
                    console.log("Selected organization: ", option);
                    setOrganizationRequired("");
                  }}
                >
                  {option.label}
                </li>
              ))
            : options.map((option) => (
                <li
                  className="option"
                  key={option.organization}
                  onClick={() => {
                    handleSelection(option);
                    setOrganizationRequired("");
                  }}
                >
                  {option.organization}
                </li>
              ))}
        </ul>
      ) : null}
    </div>
  );
};
